import React from 'react';
import SendSMSNew from '../SendSMSNew';

const AdminSendSMSNew = () => {
  return <SendSMSNew isAdmin={true} />;
};

export default AdminSendSMSNew;
